import _ from 'lodash';
import { encodeQueryParams, useQueryParams } from 'use-query-params';

// See README.md for usage & API
export default function useQueryParamsHookFactory(config, defaults) {
  const [allQueryParams, setAllQueryParams] = useQueryParams({ ...config });

  const keys = _.keys({ ...config });
  const scopedQueryParams = _.pick(allQueryParams, keys);

  // Update query params scoped to this hook factory and set them to new values
  // or clear the key (i.e. undefined) if it's being set to the default
  function handleSetScopedQueryParams(queryParamsToSet) {
    const newQueryParams = _.mapValues(_.pick(queryParamsToSet, keys), (value, key) =>
      value === defaults[key] ? undefined : value
    );

    setAllQueryParams(newQueryParams);
  }

  function pickParamsMinusDefaults(map) {
    return _.pickBy(map, (_value, key) => !_.isEqual(map[key], defaults[key]));
  }

  // Take all query params, change one of them, remove anything that's set to its default value,
  // encode for usage with <Link>
  function handleGenerateScopedQueryParams(newKey, newValue) {
    if (_.includes(keys, newKey)) {
      const queryParamsToSet = { ...scopedQueryParams, [newKey]: newValue };

      const queryParamsToSetMinusDefaults = pickParamsMinusDefaults(queryParamsToSet);

      return encodeQueryParams({ ...config }, queryParamsToSetMinusDefaults);
    }

    console.error(`handleGenerateScopedQueryParams on incorrect key ${newKey}, value: ${newValue}`);
    return {};
  }

  function handleResetScopedQueryParams() {
    handleSetScopedQueryParams(defaults);
  }

  return {
    generateQueryParams: handleGenerateScopedQueryParams,
    queryParams: scopedQueryParams,
    queryParamsMinusDefaults: pickParamsMinusDefaults(scopedQueryParams),
    resetQueryParams: handleResetScopedQueryParams,
    setQueryParams: handleSetScopedQueryParams,
    defaults,
  };
}
